import React from 'react';
import {ToggleButton, ToggleButtonGroup} from '@mui/material';
import {BAR_SORT_MODES} from './barSort';
import {useColorMode} from '../../context/colorMode/colorMode.context';

/* "Group order · Highest first · Lowest first" — the sort control of a bar list.

     const [sortMode, setSortMode] = useState('group');
     <SortToggle value={sortMode} onChange={setSortMode}/>
     …sortBars(GROUPS, sortMode)… */
const NAVY = '#052F44';

export const SortToggle = ({value = 'group', onChange, modes = BAR_SORT_MODES, size = 'small', sx}) => {
    // Dark mode: the selected option was navy on a navy tint — invisible on a
    // dark card. It reads white on a light tint there instead.
    const {isDark} = useColorMode();
    return (
    <ToggleButtonGroup
        exclusive
        size={size}
        value={value}
        onChange={(_, v) => { if (v) onChange(v); }}
        aria-label="Sort bars"
        sx={{
            flexShrink: 0,
            '& .MuiToggleButton-root': {
                textTransform: 'none', fontSize: '12px', fontWeight: 600, lineHeight: 1.2, px: 1.25, py: 0.5,
                color: isDark ? 'rgba(255,255,255,0.6)' : '#6A7282', borderColor: 'var(--brand-border, #E5E7EB)',
            },
            '& .MuiToggleButton-root.Mui-selected': isDark
                ? {color: '#FFFFFF', backgroundColor: 'rgba(255, 255, 255, 0.14)'}
                : {color: NAVY, backgroundColor: 'rgba(5, 47, 68, 0.08)'},
            '& .MuiToggleButton-root.Mui-selected:hover': {backgroundColor: isDark ? 'rgba(255, 255, 255, 0.2)' : 'rgba(5, 47, 68, 0.12)'},
            ...sx,
        }}
    >
        {modes.map((m) => (
            <ToggleButton key={m.value} value={m.value} aria-label={m.label}>{m.label}</ToggleButton>
        ))}
    </ToggleButtonGroup>
    );
};

export default SortToggle;
